import { render, staticRenderFns } from "./NewRowTwoManual.vue?vue&type=template&id=0ae4d5ba&"
import script from "./NewRowTwoManual.vue?vue&type=script&lang=js&"
export * from "./NewRowTwoManual.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0ae4d5ba')) {
      api.createRecord('0ae4d5ba', component.options)
    } else {
      api.reload('0ae4d5ba', component.options)
    }
    module.hot.accept("./NewRowTwoManual.vue?vue&type=template&id=0ae4d5ba&", function () {
      api.rerender('0ae4d5ba', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/js/components/homepage/NewRowTwoManual.vue"
export default component.exports